import { render, staticRenderFns } from "./admissionPayment.vue?vue&type=template&id=6cb50c2f&scoped=true&"
import script from "./admissionPayment.vue?vue&type=script&lang=js&"
export * from "./admissionPayment.vue?vue&type=script&lang=js&"
import style0 from "./admissionPayment.vue?vue&type=style&index=0&id=6cb50c2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb50c2f",
  null
  
)

export default component.exports